export const isActivePage = (path: string, pages: string[]) => {
  const splitedPath = path.substring(1).split('/');

  for (let i = 0; i < pages.length; i++) {
    const splitedPage = pages[i].substring(1).split('/');

    for (let j = 0; j < splitedPage.length; j++) {
      if (splitedPage[j] === ':id') {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (splitedPage[j] !== splitedPath[j]) {
        break;
      }

      if (j === splitedPage.length - 1) {
        return true;
      }
    }
  }

  return false;
};
